/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFareBasisCodeFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeFareBasisCode, serializeFareBasisCodeCreateRequest, serializeFareBasisCodeUpdateRequest, type FareBasisCode, type FareBasisCodeCreateRequest, type FareBasisCodeUpdateRequest, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { FareBasisCodeItemRequestBuilderNavigationMetadata, FareBasisCodeItemRequestBuilderRequestsMetadata, type FareBasisCodeItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /FareBasisCode
 */
export interface FareBasisCodeRequestBuilder extends BaseRequestBuilder<FareBasisCodeRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.FareBasisCode.item collection
     * @param id Unique identifier of the item
     * @returns {FareBasisCodeItemRequestBuilder}
     */
     byId(id: number) : FareBasisCodeItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FareBasisCode[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<FareBasisCodeRequestBuilderGetQueryParameters> | undefined) : Promise<FareBasisCode[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FareBasisCode>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: FareBasisCodeCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FareBasisCode | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: FareBasisCodeUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<FareBasisCodeRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FareBasisCodeCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: FareBasisCodeUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface FareBasisCodeRequestBuilderGetQueryParameters {
    isActive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const FareBasisCodeRequestBuilderUriTemplate = "{+baseurl}/FareBasisCode";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FareBasisCodeRequestBuilderNavigationMetadata: Record<Exclude<keyof FareBasisCodeRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: FareBasisCodeItemRequestBuilderRequestsMetadata,
        navigationMetadata: FareBasisCodeItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FareBasisCodeRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: "{+baseurl}/FareBasisCode?isActive={isActive}",
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createFareBasisCodeFromDiscriminatorValue,
    },
    post: {
        uriTemplate: FareBasisCodeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFareBasisCodeFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFareBasisCodeCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: FareBasisCodeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFareBasisCodeUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
